import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute } from '@nu-art/ts-common';
export const ApiDef_ContextRule = {
    _v1: {
        compare: {
            method: HttpMethod.POST,
            path: '/v1/context-rules/compare',
            timeout: 5 * Minute
        }
    }
};
//# sourceMappingURL=api-def.js.map